import { isPipelineWithParent } from '@/core/pipeline';
import { getCellByPipelineIdOrThrow } from '@/core/cell/cells';
import { isCellWithPipeline } from '@/core/cell';

import { getCellTabId, getExplorationCellsByTab } from '@/core/exploration/tabs';
import { getExplorationCell } from '@/core/exploration';

import { Exploration, Pipeline } from '../types';

export const pipelineColor = (index: number | undefined, colors: string[]) =>
  index !== undefined ? colors[index % colors.length] : undefined;

export const getParentPipelineColor = (exploration: Exploration, pipeline: Pipeline) => {
  if (!isPipelineWithParent(pipeline)) {
    return;
  }

  return getPipelineColorByPipelineId(exploration, pipeline.parentId);
};

export const getPipelineColor = (exploration: Exploration, pipeline: Pipeline) =>
  getPipelineColorByPipelineId(exploration, pipeline.pipelineId);

const getPipelineColorByPipelineId = (exploration: Exploration, pipelineId: string) => {
  const cell = getCellByPipelineIdOrThrow(exploration.view.cells, pipelineId);
  const tabId = getCellTabId(exploration, cell.id);
  const cells =
    tabId !== undefined ? getExplorationCellsByTab(exploration, tabId) : exploration.view.cells;
  const pipelineIds = cells.filter(isCellWithPipeline).map((cell) => cell.pipeline.pipelineId);

  return pipelineIds.indexOf(pipelineId);
};

export const getPipelineColorByCellId = (exploration: Exploration, cellId: string) => {
  const cell = getExplorationCell(exploration, cellId);
  if (cell === undefined || !isCellWithPipeline(cell)) {
    return;
  }

  return getPipelineColor(exploration, cell.pipeline);
};
